import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    putAwayValidationBase: {
      fontSize: 20,
      padding: '10px',
      textAlign: 'center'
    },
    putAwayValidationError: {
      color: '#ED4337'
    },
    putAwayValidationSuccess: {
      color: '#33A820'
    }
  })
)
